<template>
  <Teleport to="body">
    <Transition name="app-toast">
      <div
        v-if="current"
        class="app-toast"
        :class="`is-${current.type}`"
        role="status"
        aria-live="polite"
      >
        {{ current.message }}
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
const { toasts } = useNotify()

/** 始终展示队列最新一条 */
const current = computed(() => {
  const list = toasts.value
  return list.length ? list[list.length - 1] : null
})
</script>

<style scoped>
/* 水平居中、贴底栏上方 */
.app-toast {
  position: fixed;
  left: 50%;
  bottom: 90px;
  z-index: 200;
  transform: translateX(-50%);
  max-width: 320px;
  text-align: center;
  line-height: 1.75;
  padding: 10px 18px;
  border-radius: 22px;
  background: #000d;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  white-space: pre-line;
  pointer-events: none;
}

.app-toast.is-error {
  color: #ff8a8a;
}

.app-toast-enter-active,
.app-toast-leave-active {
  transition:
    opacity 0.25s ease,
    transform 0.25s ease;
}

.app-toast-enter-from,
.app-toast-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(20px);
}
</style>
